import { API_ENDPOINTS, apiService } from "../api";
import { getApiErrorStatus } from "../apiErrors";
import { toAllowedKeys, toAllowListKeys } from "./betaFeaturesMappers";
import type {
  AllowedBetaFeaturesResponse,
  BetaAllowListSettingResponse,
} from "./betaFeatures.types";

/** Keys the organization lets members turn on. An api-service without the route (404) allows none. */
export const fetchAllowedBetaFeatures = async (): Promise<string[]> => {
  try {
    const response = await apiService.get<AllowedBetaFeaturesResponse>(
      API_ENDPOINTS.betaFeatures.allowed,
    );
    return toAllowedKeys(response);
  } catch (error) {
    if (getApiErrorStatus(error) === 404) return [];
    throw error;
  }
};

/**
 * The admin's allow-list, or `null` when the setting does not exist yet (the db migration has
 * not run): the Org panel then shows an "available after the next update" card.
 */
export const fetchBetaAllowList = async (): Promise<string[] | null> => {
  try {
    const response = await apiService.get<BetaAllowListSettingResponse>(
      API_ENDPOINTS.betaFeatures.allowList,
    );
    return toAllowListKeys(response);
  } catch (error) {
    if (getApiErrorStatus(error) === 404) return null;
    throw error;
  }
};

/** Replaces the whole allow-list. */
export const putBetaAllowList = async (keys: string[]): Promise<string[]> =>
  toAllowListKeys(
    await apiService.put<BetaAllowListSettingResponse>(API_ENDPOINTS.betaFeatures.allowList, {
      value: keys,
    }),
  );

/** Back to the platform default (none allowed). */
export const resetBetaAllowList = async (): Promise<string[]> =>
  toAllowListKeys(
    await apiService.delete<BetaAllowListSettingResponse>(API_ENDPOINTS.betaFeatures.allowList),
  );
